export default __webpack_public_path__ + "static/media/how-it-works.fc16f68c.png";